import {
  listConversations,
  getConversation,
  createConversation,
  deleteConversation as deleteConversationApi,
  getTools,
  getSettings,
  updateSettings as updateSettingsApi,
  stopStreaming as stopStreamingApi,
} from '@/services/aiAgentService'

const state = {
  conversations: [],
  activeConversationId: null,
  messages: [],
  streaming: false,
  streamingText: '',
  tools: [],
  settings: {},
  currentModel: 'claude-sonnet-4-5-20250929',
}

const mutations = {
  SET_CONVERSATIONS(state, conversations) {
    state.conversations = conversations
  },
  SET_ACTIVE_CONVERSATION(state, id) {
    state.activeConversationId = id
  },
  SET_MESSAGES(state, messages) {
    state.messages = messages
  },
  ADD_MESSAGE(state, message) {
    state.messages.push(message)
  },
  UPDATE_LAST_MESSAGE(state, message) {
    if (state.messages.length > 0) {
      state.messages.splice(state.messages.length - 1, 1, message)
    }
  },
  SET_STREAMING(state, streaming) {
    state.streaming = streaming
  },
  SET_STREAMING_TEXT(state, text) {
    state.streamingText = text
  },
  APPEND_STREAMING_TEXT(state, text) {
    state.streamingText += text
  },
  SET_TOOLS(state, tools) {
    state.tools = tools
  },
  SET_SETTINGS(state, settings) {
    state.settings = settings
  },
  SET_CURRENT_MODEL(state, model) {
    state.currentModel = model
  },
  CLEAR_MESSAGES(state) {
    state.messages = []
  },
}

const actions = {
  async loadConversations({ commit }) {
    const { data, error } = await listConversations()
    if (error) return
    commit('SET_CONVERSATIONS', data.conversations || data.list || [])
  },

  async loadConversation({ commit }, id) {
    const { data, error } = await getConversation(id)
    if (error) return
    commit('SET_ACTIVE_CONVERSATION', id)
    commit('SET_MESSAGES', data.messages || [])
  },

  async createConversation({ commit, dispatch }, params) {
    const { data, error } = await createConversation(params)
    if (error) return null
    const id = data.id || data.conversation_id
    commit('SET_ACTIVE_CONVERSATION', id)
    commit('CLEAR_MESSAGES')
    await dispatch('loadConversations')
    return data
  },

  async deleteConversation({ commit, state, dispatch }, id) {
    const { error } = await deleteConversationApi(id)
    if (error) return
    if (state.activeConversationId === id) {
      commit('SET_ACTIVE_CONVERSATION', null)
      commit('CLEAR_MESSAGES')
    }
    await dispatch('loadConversations')
  },

  async loadTools({ commit }) {
    const { data, error } = await getTools()
    if (error) return
    commit('SET_TOOLS', data.tools || [])
  },

  async loadSettings({ commit }) {
    const { data, error } = await getSettings()
    if (error) return
    commit('SET_SETTINGS', data)
    if (data.model) {
      commit('SET_CURRENT_MODEL', data.model)
    }
  },

  async updateSettings({ commit }, params) {
    const { data, error } = await updateSettingsApi(params)
    if (error) return
    commit('SET_SETTINGS', data)
    if (params.model) {
      commit('SET_CURRENT_MODEL', params.model)
    }
  },

  startStreaming({ commit }) {
    commit('SET_STREAMING', true)
    commit('SET_STREAMING_TEXT', '')
  },

  async stopStreaming({ commit, state }) {
    if (state.activeConversationId) {
      await stopStreamingApi(state.activeConversationId)
    }
    commit('SET_STREAMING', false)
  },

  appendStreamingText({ commit }, text) {
    commit('APPEND_STREAMING_TEXT', text)
  },

  finishStreaming({ commit, state }) {
    if (state.streamingText) {
      commit('ADD_MESSAGE', {
        role: 'assistant',
        content: state.streamingText,
      })
    }
    commit('SET_STREAMING', false)
    commit('SET_STREAMING_TEXT', '')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
